import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Body from './body';
import Login from '../modules/login';
import IdleTimer from 'react-idle-timer';
import Storage from './../services/local-store';
import postService from './../services/httpService';
import networkList from '../constants/networkList';
const $ = require('jquery');
require('bootstrap');
const {homepage} = networkList;
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date()
    }; 
    // this.idleTimer = null null
    // this.onAction = this._onAction.bind(this)
    // this.onActive = this._onActive.bind(this)
    // this.onIdle = this._onIdle.bind(this)
  }
  componentDidMount() {
    this.checkAuthToken();
    if ($('.App').outerHeight(true) > $(window).height()) {
      $('footer').css({ 'position': 'relative', top: '10px' });
    } else {
      $('footer').css({ 'position': 'relative', top: 'unset' });
    }
  }
  componentWillMount() {
    this.checkAuthToken();
  }
  // logout() {
  //   const setHref = str => (window.location.href = str);
  //    Storage.clearAll();
  //    setHref('/');
  // }
  checkAuthToken() {
    const setHref = str => (window.location.href = str);
    let currenthref = window.location.pathname;
    let split_currenthref = currenthref.split("/")
    if(split_currenthref.includes("digital-signature")){
      currenthref = `${homepage}/digital-signature`
    }
    console.log("test the refresh... App" + currenthref);
    if (currenthref !== `${homepage}/tv-display` && currenthref !== `${homepage}/nurse-display` && currenthref !== `${homepage}/nurse-stations` && currenthref !== `${homepage}/digital-signature`) {
      postService('checkAuthToken', 'GET', "").then(res => {
        if (!(res.success) && !(res.status)) {
          // console.log("token service checking in....");
          // console.log(res)
          if (currenthref !== `${homepage}/tv-settings/start-counter` && currenthref !== '/' && currenthref !== `${homepage}/tv-screen/tv1` && currenthref !== `${homepage}/tv-screen/tv2` && currenthref !== `${homepage}/tv-screen/tv3` && currenthref !== `${homepage}/tv-screen/tv4` && currenthref !== `${homepage}/tv-screen/tv5` && currenthref !== `${homepage}/tv-screen/ramesh_tv`) {
            // Storage.clearAll();
            // setHref('/');
          }
        }
      });
    }
  }
  render() {

    return (
      <div className="App">
        {/*<IdleTimer
          ref={ref => { this.idleTimer = ref }}
          element={document}
          onActive={this.onActive}
          onIdle={this.onIdle}
          onAction={this.onAction}
          debounce={250}
          timeout={1000 * 60 * 60} />*/}
        <Router basename='/'>
          <Route exact path="/" component={Login} />
          <Route exact path="/:id/:slug?" component={Body} />
        </Router>
      </div>
    );
  }

  // _onAction(e) {
  //   //console.log('user did something', e)
  // }

  // _onActive(e) {
  //   //console.log('user is active', e)
  //   //console.log('time remaining', this.idleTimer.getRemainingTime()) 
  // }

  // _onIdle(e) {
  //   console.log('user is idle', e)
  //   console.log('last active', this.idleTimer.getLastActiveTime())
  //   const currenthref = window.location.pathname;
  //   console.log("idle checking...");
  //   console.log(currenthref);
  //   if(currenthref !== '/tv-settings/start-counter'){
  //     this.logout();
  //   }

  // }
}

export default App;
